import { Pipe, PipeTransform } from '@angular/core'
import {
    OrganizationStatusPipe,
    OrganizationStatuses,
} from './organization-status.pipe'

@Pipe({
    name: 'organizationStatusClass',
    standalone: true,
})
export class OrganizationStatusClassPipe implements PipeTransform {
    transform(entity: OrganizationStatuses): string {
        const status = new OrganizationStatusPipe().transform(entity)

        switch (status) {
            case 'Active':
                return 'bg-green-50 text-green-700 ring-1 ring-inset ring-green-600/20'
            case 'Pending':
                return 'bg-yellow-50 text-yellow-800 ring-1 ring-inset ring-yellow-600/20'
            case 'Suspended':
                return 'bg-red-50 text-red-700 ring-1 ring-inset ring-red-600/10'
            default:
                return 'bg-gray-100 text-gray-600'
        }
    }
}
